<mat-card [ngClass]="bgClass()">
    @if (!hideHeader()) {
        <mat-card-header>
            @if (icon()) {
                <div mat-card-avatar>
                    <fa-icon class="icon-lg" [icon]="['fal', icon()]"></fa-icon>
                </div>
            }
            @if (format()) {
                <mat-card-title>{{ count() | money: currencyType }}</mat-card-title>
            }
            @if (!format()) {
                <mat-card-title>{{ count() }}</mat-card-title>
            }
            @if (label()) {
                <mat-card-subtitle>{{ label() | translate }}</mat-card-subtitle>
            }
        </mat-card-header>
    }
    <mat-card-content fxFlexAlign="stretch">
        <div style="height: 100%">
            <ng-content></ng-content>
        </div>
    </mat-card-content>
    @if (!hideActions()) {
        <mat-card-actions>
            @if (url()) {
                <button matButton="tonal" style="background-color: transparent; color: #fff" (click)="goToDetails()">
                    {{ 'GENERAL.TITLE.DETAILS' | translate }}
                </button>
            }
            <button matButton="tonal" style="background-color: transparent; color: #fff" (click)="refresh()">
                <fa-icon
                    matSuffix
                    style="font-size: 16px; float: right; cursor: pointer"
                    [icon]="['fal', 'sync']"
                    [animation]="refreshing() ? 'spin' : undefined" />
            </button>
        </mat-card-actions>
    }
</mat-card>
